var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightOrangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 33,
    viewBox: "0 0 18 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3128 14.7172C17.7528 15.182 18 15.8123 18 16.4695C18 17.1268 17.7528 17.7571 17.3128 18.2219L4.03532 32.2433C3.81881 32.48 3.55982 32.6689 3.27347 32.7988C2.98711 32.9287 2.67913 32.997 2.36748 32.9999C2.05584 33.0028 1.74678 32.9401 1.45833 32.8154C1.16988 32.6908 0.907821 32.5068 0.687446 32.274C0.467071 32.0413 0.292793 31.7646 0.174779 31.46C0.0567654 31.1554 -0.00261946 30.829 8.8649e-05 30.4999C0.00279676 30.1708 0.0675442 29.8455 0.190553 29.5431C0.313561 29.2407 0.492367 28.9672 0.716538 28.7386L12.3346 16.4695L0.716538 4.2005C0.288997 3.73303 0.0524238 3.10694 0.0577715 2.45706C0.0631191 1.80718 0.30996 1.18552 0.745129 0.725964C1.1803 0.266415 1.76898 0.00574114 2.38438 9.53959e-05C2.99978 -0.00555416 3.59266 0.244274 4.03532 0.69577L17.3128 14.7172Z",
    fill: "#F39422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightOrangeArrow);
export default __webpack_public_path__ + "static/media/right-orange-arrow.9b7c0169951176cbfef8cb86950bb6dc.svg";
export { ForwardRef as ReactComponent };